/* eslint-disable no-magic-numbers */

import { IApiPageParams } from '@senet-id/core/types';

import { EWorkstationType } from './map';

export interface IReservationValidateWorkstation {
  workstation_type_id: EWorkstationType;
  workstation_id: number;
  is_available: boolean;
  num: number;
}

export interface IReservationValidateData {
  reservations: Array<{ workstation: IReservationValidateWorkstation }>;
  promo_code: string | null;
  office_id: number;
  from_date: string;
  to_date: string;
}

export interface IValidReservationItem {
  workstation: IReservationValidateWorkstation;
  reservation_code: string | null;
  commission: string;
  deposit: string;
}

export interface IValidReservationTotal {
  payable_amount_without_discount: string;
  payable_amount: string;
  commission: string;
  discount: string;
}

export interface IValidReservationData {
  reservations: IValidReservationItem[];
  total: IValidReservationTotal;
  user_login: string | null;
  promo_code: string | null;
  account_balance: string;
  from_date: string;
  to_date: string;
}

export enum EReservationStatus {
  Active = 1,
  Used = 2,
  Cancelled = 3,
  Expired = 4,
  Unpaid = 5,
  Deleted = 6,
  PrematurelyReleased = 7,
}

export interface IReservationsParams extends IApiPageParams {
  office_id?: number | null;
  status?: EReservationStatus;
}

export interface IReservationWorkstation {
  reservation_description: string | null;
  workstation_type_id: EWorkstationType;
  reservation_code: string;
  reservation_id: number;
  device_name: string;
  num: number;
  id: number;
}

export interface IReservation {
  workstations: IReservationWorkstation[];
  office: { id: number; name: string };
  is_group_reservation: boolean;
  status: EReservationStatus;
  duration_minutes: number;
  status_display: string;
  total_amount: string;
  start_date: string;
  user_login: string;
  end_date: string;
  ins_date: string;
  user_id: number;
  id: number;
}

export interface IReservationsGroup {
  reservations: IReservation[];
  date: string;
}
